import React, { useMemo, useState } from "react";
import { getAccuratePixels } from "../../utils/global";
import IconModal from "../Partial/IconModal";
import { icon_mapping } from "../../assets/Icons/iconMapping";
import DeleteIcon from "../../assets/Icons/DeleteIcon";

function IconSwitch({
  isDownloadMode,
  id,
  selectedIcons,
  downloadAs,
  handleSetSelectIcon,
  deleteSelectedicon,
  type,
  marginTop,
  marginLeft,
  left,
  top,
  right,
  bottom,
  uid,
  frame,
}) {
  const [openIconModal, setOpenIconModal] = useState(false);

  const width = isDownloadMode ? 188 : getAccuratePixels(188);
  const height = isDownloadMode ? 188 : getAccuratePixels(188);

  const iconWidth = isDownloadMode ? 100 : getAccuratePixels(100);
  const iconHeight = isDownloadMode ? 100 : getAccuratePixels(100);

  const handleOnSuccess = (data) => {
    handleSetSelectIcon(data, `${uid}//${id}`);

    setOpenIconModal(false);
  };
  const getId = `${uid}//${id}`;

  const Icon = useMemo(() => {
    const componentIcon = selectedIcons[getId];
    const typesByIcon = icon_mapping[componentIcon?.type];

    if (typesByIcon) {
      const iconsBySection = typesByIcon?.find(
        (item) => item?.name == componentIcon?.section
      );

      if (iconsBySection) {
        const icon = iconsBySection?.icons?.find(
          (item) => item?.id == componentIcon?.id
        );

        if (icon) {
          return icon?.icon;
        }
      }
    }

    return;
  }, [selectedIcons]);

  const isDownloadIcon = downloadAs == "icon-png" || downloadAs == "pdf";
  const isDownloadPng = downloadAs == "icon-png" || downloadAs == "cutout-png";

  const iconDimansion = isDownloadMode ? 80 : getAccuratePixels(80);

  const mTop = isDownloadMode ? marginTop : getAccuratePixels(marginTop);
  const mLeft = isDownloadMode ? marginLeft : getAccuratePixels(marginLeft);

  const dTop = isDownloadMode ? top : getAccuratePixels(top);
  const dLeft = isDownloadMode ? left : getAccuratePixels(left);

  const dRight = isDownloadMode ? right : getAccuratePixels(right);
  const dBottom = isDownloadMode ? bottom : getAccuratePixels(bottom);

  const assosiatedIcons = useMemo(() => {
    if (type == "2" && frame == "laminate_varient") {
      return icon_mapping.switchSelected;
    }

    if (type == "fan" && frame == "laminate_varient") {
      return icon_mapping.fanSelected;
    }

    if (type == "fan-volume-up" && frame == "laminate_varient") {
      return icon_mapping.fanPlusSelected;
    }

    if (type == "fan-volume-down" && frame == "laminate_varient") {
      return icon_mapping.fanMinusSelected;
    }

    if (type == "master" && frame == "laminate_varient") {
      return icon_mapping.master;
    }

    if (frame == "laminate_varient") {
      return [];
    }

    if (type == "2") {
      return [
        ...icon_mapping?.switch,
        ...icon_mapping?.master,
        ...icon_mapping?.fan,
        ...icon_mapping?.fanPlus,
        ...icon_mapping?.fanMinus,
        ...icon_mapping?.curtainOpen,
        ...icon_mapping?.curtainClose,
      ];
    }

    if (type == "master") {
      return [
        ...icon_mapping?.master,
        ...icon_mapping?.switch,
        ...icon_mapping?.fan,
        ...icon_mapping?.fanPlus,
        ...icon_mapping?.fanMinus,
        ...icon_mapping?.curtainOpen,
        ...icon_mapping?.curtainClose,
      ];
    }

    if (type === "curtain-up") {
      return [
        ...icon_mapping?.curtainOpen,
        ...icon_mapping?.master,
        ...icon_mapping?.switch,
        ...icon_mapping?.fan,
        ...icon_mapping?.fanPlus,
        ...icon_mapping?.fanMinus,
        ...icon_mapping?.curtainClose,
      ];
    }

    if (type == "curtain-down") {
      return [
        ...icon_mapping?.curtainClose,
        ...icon_mapping?.curtainOpen,
        ...icon_mapping?.master,
        ...icon_mapping?.switch,
        ...icon_mapping?.fan,
        ...icon_mapping?.fanPlus,
        ...icon_mapping?.fanMinus,
      ];
    }

    if (type == "fan") {
      return [
        ...icon_mapping?.fan,
        ...icon_mapping?.curtainClose,
        ...icon_mapping?.curtainOpen,
        ...icon_mapping?.master,
        ...icon_mapping?.switch,
        ...icon_mapping?.fanPlus,
        ...icon_mapping?.fanMinus,
      ];
    }

    if (type == "fan-volume-up") {
      return [
        ...icon_mapping?.fanPlus,
        ...icon_mapping?.fanMinus,
        ...icon_mapping?.fan,
        ...icon_mapping?.curtainClose,
        ...icon_mapping?.curtainOpen,
        ...icon_mapping?.master,
        ...icon_mapping?.switch,
      ];
    }

    if (type == "fan-volume-down") {
      return [
        ...icon_mapping?.fanMinus,
        ...icon_mapping?.fanPlus,
        ...icon_mapping?.fan,
        ...icon_mapping?.curtainClose,
        ...icon_mapping?.curtainOpen,
        ...icon_mapping?.master,
        ...icon_mapping?.switch,
      ];
    }
  }, [type]);

  const isLoadMore = [
    "fan",
    "fan-volume-up",
    "fan-volume-down",
    "master",
    "curtain-up",
    "curtain-down",
    "2",
  ].includes(type);

  return (
    <>
      <div
        style={{
          position: "absolute",
          top: dTop,
          left: dLeft,
          right: dRight,
          bottom: dBottom,
        }}
      >
        <div
          style={{
            width: width,
            height: height,
            border: isDownloadIcon ? "none" : "1px solid #6495ED",
            borderRadius: "50%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "relative",
            // marginTop: mTop,
            // marginLeft: mLeft,
          }}
          onClick={() => {
            if (!Icon) {
              setOpenIconModal(true);
            }
          }}
        >
          {Icon ? (
            // <img
            //   src={icon}
            //   alt={`Icon ${id}`}
            //   style={{
            //     width: iconWidth,
            //     height: iconHeight,
            //   }}
            // />
            <div className="icon-container">
              <Icon
                className={`${
                  isDownloadPng
                    ? "switch-icon-color-black"
                    : "switch-icon-color"
                }`}
                style={{
                  width: iconDimansion,
                  height: iconDimansion,
                }}
              />
            </div>
          ) : null}

          {!downloadAs && Icon && (
            <div
              className="absolute -top-3 right-0 cursor-pointer "
              onClick={() => deleteSelectedicon(getId)}
            >
              <DeleteIcon />
            </div>
          )}
        </div>
      </div>

      {openIconModal && (
        <IconModal
          onClose={() => {
            setOpenIconModal(false);
          }}
          onSuccess={handleOnSuccess}
          assosiatedIcons={assosiatedIcons}
          isLoadMore={isLoadMore}
          type={type}
        />
      )}
    </>
  );
}

export default IconSwitch;
